import React from "react";

interface HeaderProps {
  headerName: string;
}

const Header: React.FC<HeaderProps> = (props) => {
  const { headerName } = props;

  return (
      <div className="page-header">
        

        <div className="d-flex align-items-end justify-content-end">
        <div className="logo">
                <img
                  alt="conscisys logo"
                  src={require("../../assets/conscisys_logo.png")}
                  className="conscisys-logo"
                />
              </div>
        </div>
        
      </div>
  );
};

export default Header;
